module.exports = __webpack_public_path__ + "static/media/2.24b6641b.png";